import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';

import { ClickOutsideModule } from 'ng-click-outside';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TabsModule } from 'primeng/tabs';
import { TooltipModule } from 'primeng/tooltip';
import { QRCodeComponent } from 'angularx-qrcode';

import { LocalizationModule } from '../../Core/Localization/localization.module';
import { PageBuilderModule } from '../../Common/PageBuilder/page-builder.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { LayoutModule } from '../../Common/Layout/layout.module';
import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { UserPreferencesComponent } from './components/UserPreferences/user-preferences.component';
import { UserPreferencesService } from './services/user-preferences.service';
import { DiscoverUserPreferencesComponent } from './components/DiscoverUserPreferences/discover-user-preferences.component';
import { GeneralPreferencesComponent } from './components/GeneralPreferences/general-preferences.component';
import { ChartsModule } from '../../Common/Charts/charts.module';
import { FilterModule } from '../../Common/Filter/filter.module';
import { LeftHandPanelDefaultFilterComponent } from './components/LeftHandPanelDefaultFilter/left-hand-panel-default-filter.component';
import { LeftHandPanelDefaultFilterService } from './services/left-hand-panel-default-filter.service';
import { MonitorUserPreferencesComponent } from './components/MonitorUserPreferences/monitor-user-preferences.component';
import { UserPreferenceFilterWrapperComponent } from './components/UserPreferencesFilterWrapper/user-preference-filter-wrapper.component';
import { ReportUserPreferencesComponent } from './components/ReportUserPreferences/report-user-preferences.component';
import { MfaManagementComponent } from '../../Bootstrap/components/MultiFactorAuthentication/mfa-management.component';
import { MfaLoginComponent } from '../../Bootstrap/components/MultiFactorAuthentication/mfa-login.component';
import { MfaSetupComponent } from '../../Bootstrap/components/MultiFactorAuthentication/mfa-setup.component';
import { FavoriteColorsPreferencesComponent } from './components/FavoriteColorsPreferences/favorite-colors-preferences.component';

@NgModule({
    imports: [
        LocalizationModule,
        PageBuilderModule,
        TabsModule,
        CommonModule,
        FormsModule,
        ButtonModule,
        MiscModule,
        ClickOutsideModule,
        CommonFormsModule,
        LayoutModule,
        AutoCompleteModule,
        SelectModule,
        InputTextModule,
        CheckboxModule,
        CommonBasicModule,
        TooltipModule,
        CoreDialogsModule,
        ChartsModule,
        FilterModule,
        QRCodeComponent,
        OverlayModule
    ],
    declarations: [
        UserPreferencesComponent,
        DiscoverUserPreferencesComponent,
        MonitorUserPreferencesComponent,
        ReportUserPreferencesComponent,
        GeneralPreferencesComponent,
        LeftHandPanelDefaultFilterComponent,
        UserPreferenceFilterWrapperComponent,
        MfaManagementComponent,
        MfaLoginComponent,
        MfaSetupComponent,
        FavoriteColorsPreferencesComponent
    ],
    exports: [
        UserPreferencesComponent,
        MfaManagementComponent,
        MfaLoginComponent,
        MfaSetupComponent
    ],
    providers: [
        UserPreferencesService,
        LeftHandPanelDefaultFilterService,
    ]
})
export class UserPreferencesModule { }
